/**
 * @generated SignedSource<<4abdfe1117d9c9395d47c80cbe357178>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeeSheetAgendaHeaderFragment_club$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club">;
  readonly " $fragmentType": "TeeSheetAgendaHeaderFragment_club";
};
export type TeeSheetAgendaHeaderFragment_club$key = {
  readonly " $data"?: TeeSheetAgendaHeaderFragment_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheetAgendaHeaderFragment_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeeSheetAgendaHeaderFragment_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FacilityLogoFragment_club"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "dfa2fb0923746422f4b80b865eca97b9";

export default node;
